import {
  IconBrandMessenger,
  IconBrandWhatsapp,
  IconMailFilled,
  IconMessageCircle2Filled,
} from '@tabler/icons-react';

import { CreateMessagingChannelDtoTypeEnum } from 'src/Services/API/generated';
import { messagingChannelsColor } from 'src/Services/Themes/lightTheme';

export const messagingChannelsConfig = [
  {
    type: CreateMessagingChannelDtoTypeEnum.Sms,
    icon: IconMessageCircle2Filled,
    color: messagingChannelsColor.greenSMS,
    label: 'SMS',
  },
  {
    type: CreateMessagingChannelDtoTypeEnum.Email,
    icon: IconMailFilled,
    color: messagingChannelsColor.blueEmail,
    label: 'Email',
  },
  {
    type: CreateMessagingChannelDtoTypeEnum.Signal,
    icon: IconMessageCircle2Filled,
    color: messagingChannelsColor.blueSignal,
    label: 'Signal',
  },
  {
    type: CreateMessagingChannelDtoTypeEnum.Whatsapp,
    icon: IconBrandWhatsapp,
    color: messagingChannelsColor.greenWhatsApp,
    label: 'WhatsApp',
  },
  {
    type: CreateMessagingChannelDtoTypeEnum.Messenger,
    icon: IconBrandMessenger,
    color: messagingChannelsColor.blueMessenger,
    label: 'Messenger',
  },
];
